// FiltersSection.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { FiltersRow } from './FiltersSection.style';
import { TimeRangeSelector } from './TimeRangeSelector/TimeRangeSelector';
import { ProductSelector } from './ProductSelector/ProductSelector';
import { TimeRangeEnum } from './TimeRangeSelector/types';
import { getPreviousMonthsDateRange } from '../../utils/utils';
import { DeviceSelector } from './DeviceSelector/DeviceSelector';
import { DeviceFilterEnum } from './DeviceSelector/types';

interface IFilterSectionProps {
  timeRange: TimeRangeEnum;
  setTimeRange: (timeRange: TimeRangeEnum) => void;
  product: string;
  setProduct: (product: string) => void;
  device: DeviceFilterEnum;
  setDevice: (device: DeviceFilterEnum) => void;
  shopId: number;
}

export default function FiltersSection({
  timeRange,
  setTimeRange,
  product,
  setProduct,
  device,
  setDevice,
  shopId,
}: IFilterSectionProps) {
  return (
    <Box>
      <FiltersRow>
        <TimeRangeSelector timeRange={timeRange} setTimeRange={setTimeRange} />
        <ProductSelector product={product} setProduct={setProduct} shopId={shopId} />
        <DeviceSelector device={device} setDevice={setDevice} />
      </FiltersRow>

      <Box mb={2}>
        <Typography
          variant='h6'
          sx={{
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#1E1E1E',
            marginBottom: '4px',
          }}
        >
          Syte’s Performance Overview
        </Typography>
        <Typography
          variant='body2'
          sx={{
            color: '#6E6E71',
            fontSize: '14px',
          }}
        >
          {getPreviousMonthsDateRange(timeRange)}
        </Typography>
      </Box>
    </Box>
  );
}
